import {useMutation} from "@tanstack/react-query";
import {downloadFile} from "../../../../../util/FileDownload";
import {exportOverseasStandardFormExcel} from "../../../../../api/main/OcApi";
import {OcSearchParamType} from "../interface";
import moment from "moment";

export const useExportOverseasStandardFormExcel = () => {
    const {mutate} = useMutation({
        mutationFn: (data: OcSearchParamType) => exportOverseasStandardFormExcel(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                downloadFile(res, `해외법인_${variables.region}_${moment().format('YYYY-MM-DD_HH_mm')}_.xlsx`)
            }
        },
    });

    return {mutate};
};
